import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import Tooltip from './Tooltip';

type TooltipLine = {
  titleKey: string;
  value?: React.ReactNode;
};

type MultiLineTooltipContentProps = {
  tooltipLines: TooltipLine[];
};

type MultiLineTooltipProps = {
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  tooltipLines: TooltipLine[];
};

const Root = styled.div`
  display: flex;
  padding-block: 2px;
  flex-direction: column;
  gap: 16px;
`;

const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const LineTitle = styled(T.Small)`
  font-weight: 700;
`;

export const MultiLineTooltipContent = ({ tooltipLines }: MultiLineTooltipContentProps) => (
  <Root>
    {tooltipLines.map(({ titleKey, value }) => (
      <DetailsWrapper key={titleKey}>
        <LineTitle>
          <FormattedMessage id={titleKey} />
        </LineTitle>
        {value ?? '-'}
      </DetailsWrapper>
    ))}
  </Root>
);

export const MultiLineTooltip = ({ tooltipLines, ...rest }: MultiLineTooltipProps) => {
  return <Tooltip {...rest} description={<MultiLineTooltipContent tooltipLines={tooltipLines} />} />;
};
